import { array, object } from 'zod';

import {
  senderConfigurationFormSchema,
  receiverConfigurationFormSchema,
  qualifyingEventConfigurationFormSchema,
  marketingContentFormSchema,
} from './components';

export const referralProgramConfigurationSchema = object({
  sender: senderConfigurationFormSchema,
  receiver: receiverConfigurationFormSchema,
  qualifyingEvent: qualifyingEventConfigurationFormSchema,
  marketingContents: array(marketingContentFormSchema).min(1),
}).strict();
